export type NameType = 'startAnimation';

export const name: NameType = 'startAnimation';
